(() => {
  const init = (root) => {
    root.querySelectorAll('[data-lbf-video-card]').forEach((card) => {
      if (card.dataset.playerReady) return;
      const video = card.querySelector('video');
      const controls = card.querySelector('.lbf-video-card__controls');
      const toggle = card.querySelector('[data-video-toggle]');
      const error = card.querySelector('[role="status"]');
      if (!video || !controls || !toggle) return;
      card.dataset.playerReady = 'true';
      const sync = () => {
        const playing = !video.paused && !video.ended;
        card.toggleAttribute('data-playing', playing);
        toggle.setAttribute('aria-label', playing ? toggle.dataset.pauseLabel : toggle.dataset.playLabel);
        toggle.setAttribute('aria-pressed', String(playing));
      };
      const play = async () => {
        if (!video.paused) { video.pause(); return; }
        document.querySelectorAll('[data-lbf-video-card] video').forEach((other) => {
          if (other !== video) other.pause();
        });
        if (error) error.hidden = true;
        try { await video.play(); } catch {
          if (error) error.hidden = false;
          video.controls = true;
        }
        sync();
      };
      toggle.addEventListener('click', play);
      video.addEventListener('click', () => { if (!video.controls) play(); });
      ['play', 'pause', 'ended'].forEach((event) => video.addEventListener(event, sync));
      video.addEventListener('error', () => { if (error) error.hidden = false; });
      video.controls = false;
      controls.hidden = false;
      sync();
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
